import { useEffect } from "react";
import { useAccount } from "wagmi";
import { useSpaceStore } from "../stores";
import { useTutorialStore } from "../stores/tutorialStore";
import { TUTORIAL_STEPS } from "../components/Tutorial/TutorialStepContent";

/**
 * Watches spaceStore and wagmi state to auto-advance tutorial steps
 * when the user performs the expected interaction.
 */
export function useTutorialTrigger() {
	const isActive = useTutorialStore((s) => s.isActive);
	const currentStep = useTutorialStore((s) => s.currentStep);
	const nextStep = useTutorialStore((s) => s.nextStep);

	const viewMode = useSpaceStore((s) => s.viewMode);
	const selectedObject = useSpaceStore((s) => s.selectedObject);
	const { isConnected } = useAccount();

	const stepDef = TUTORIAL_STEPS[currentStep];

	// Step 2: detect pan or zoom interaction
	useEffect(() => {
		if (!isActive || stepDef?.interactionType !== "panOrZoom") return;

		const unsub = useSpaceStore.subscribe((state, prev) => {
			const curr = state.viewMode === "galaxy" ? state.galaxyView : state.systemView;
			const prevView = prev.viewMode === "galaxy" ? prev.galaxyView : prev.systemView;
			if (
				curr.scale !== prevView.scale ||
				curr.offsetX !== prevView.offsetX ||
				curr.offsetY !== prevView.offsetY
			) {
				nextStep();
			}
		});
		return unsub;
	}, [isActive, stepDef?.interactionType, nextStep]);

	// Step 3: detect entering a star system
	useEffect(() => {
		if (!isActive || stepDef?.interactionType !== "enterSystem") return;
		if (viewMode === "system") {
			nextStep();
		}
	}, [isActive, stepDef?.interactionType, viewMode, nextStep]);

	// Step 4: detect planet selection
	useEffect(() => {
		if (!isActive || stepDef?.interactionType !== "selectPlanet") return;
		if (selectedObject?.type === "planet") {
			nextStep();
		}
	}, [isActive, stepDef?.interactionType, selectedObject, nextStep]);

	// Step 6: detect wallet connection
	useEffect(() => {
		if (!isActive || stepDef?.interactionType !== "walletConnect") return;
		if (isConnected) {
			nextStep();
		}
	}, [isActive, stepDef?.interactionType, isConnected, nextStep]);
}
